module.exports = __webpack_public_path__ + "static/img/IMG_20151222_182318.4b69c268.jpg";